import {useTokenStore} from "@/stores/token";
import grpc from "@/services/grpc";

export default class {
    grpcClient;

    constructor() {
        this.grpcClient = new grpc();
    }

    persist(session) {
        useTokenStore().setSession(session.accessToken, session.refreshToken, session.user);
    }

    async register(email, name, password) {
        const session = await this.grpcClient.register(email, name, password);
        this.persist(session);
        return session.user;
    }

    async login(email, password) {
        const session = await this.grpcClient.login(email, password);
        this.persist(session);
        return session.user;
    }

    async logout() {
        const store = useTokenStore();
        const refreshToken = store.getRefreshToken();
        store.clear();
        await this.grpcClient.logout(refreshToken);
    }

    async validateToken() {
        const store = useTokenStore();
        const accessToken = store.getAccessToken();
        if (accessToken === null || accessToken === undefined || accessToken === '' || accessToken === 'null') {
            return false;
        }
        try {
            const user = await this.grpcClient.getCurrentUser();
            store.setUser(user);
            return true;
        } catch (err) {
            if (err && err.code === 16) {
                store.clear();
            }
            return false;
        }
    }

}
